var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPeople = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 14,
  viewBox: "0 0 18 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.258 7.144a4.03 4.03 0 0 0 1.393-3.048 4.097 4.097 0 0 0-8.193 0A4.031 4.031 0 0 0 3.85 7.144 6.554 6.554 0 0 0 0 13.11a.82.82 0 1 0 1.639 0 4.916 4.916 0 0 1 9.831 0 .819.819 0 1 0 1.639 0 6.554 6.554 0 0 0-3.851-5.965Zm-2.704-.59a2.458 2.458 0 1 1 0-4.915 2.458 2.458 0 0 1 0 4.915Zm7.98.263A4.096 4.096 0 0 0 11.47 0a.82.82 0 1 0 0 1.639 2.458 2.458 0 0 1 2.458 2.457 2.459 2.459 0 0 1-1.229 2.122.819.819 0 0 0-.04 1.393l.319.213.106.058a5.735 5.735 0 0 1 3.277 5.227.819.819 0 1 0 1.639 0 7.373 7.373 0 0 0-3.466-6.292Z"
})));
export default SvgPeople;